import { useAppSelector } from "store/hooks";

const useFieldNameSuggestions = (): string[] => {
  const fieldNameSuggestionsObject = useAppSelector(
    (state) => state.developer.edit.editor.fieldNameSuggestionsObject
  );

  return fieldNameSuggestionsObject ?? [];
};

export default useFieldNameSuggestions;
